var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotesLeftGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50132 3C9.69553 3 12.0013 5.63705 12.0012 9.54163C11.9808 15.2148 7.71601 19.2258 1.56344 19.9961C0.992629 20.0676 0.772531 19.2769 1.29818 19.0431C3.65896 17.9934 4.85128 16.6613 5.00529 15.3428C5.12035 14.3578 4.58486 13.4949 3.91246 13.3333C2.16927 12.9144 1.00132 10.7436 1.00132 8.5C1.00132 5.46243 3.46376 3 6.50132 3Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5013 3C21.6955 3 24.0013 5.63705 24.0013 9.54163C23.9808 15.2148 19.716 19.2258 13.5634 19.9961C12.9926 20.0676 12.7725 19.2769 13.2982 19.0431C15.659 17.9934 16.8513 16.6613 17.0053 15.3428C17.1204 14.3578 16.5849 13.4949 15.9125 13.3333C14.1693 12.9144 13.0013 10.7436 13.0013 8.5C13.0013 5.46243 15.4638 3 18.5013 3Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesLeftGrey);
export default __webpack_public_path__ + "static/media/quotes-left-grey.2a7fccccf0fd82cd50f8972c5d708f68.svg";
export { ForwardRef as ReactComponent };